<template>

  <section class="o-section">
    <div class="o-section__wrapper is-bottom-left" ref="wrapper">

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="7a">
          <div v-for="line in copy.top" v-html="line" :key="line"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="active">
        <figure class="o-section__figure" ref="figureC" data-scene="7c">
          <Img :src="require('@/assets/scene7/spread7_c.png')" filename="spread7_c" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="7b">
          <Img :src="require('@/assets/scene7/spread7_b.png')" filename="spread7_b" />
        </figure>

        <figure class="o-section__figure" ref="figureB2" data-scene="7b2">
          <Img :src="require('@/assets/scene7/spread7_b2.png')" filename="spread7_b2" />
        </figure>

        <figure class="o-section__figure" ref="figureA" data-scene="7a">
          <Img :src="require('@/assets/scene7/spread7_a.png')" filename="spread7_a" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'

export default {
  name: 'Scene7',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene7', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: this.$refs.figureA,
        translateY: ['40px', '0px'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB2,
        translateX: ['-20px', '0px'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB,
        translateX: ['-160px', '0px'],
        translateY: ['-60px', '0px'],
        delay: 500,
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB.querySelector('div'),
        translateY: ['0', '-10px'],
        // delay: 3500,
        loop: true,
        direction: 'alternate',
        duration: this.options.durationRegular,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB,
        opacity: [0, 1],
        delay: 500,
        duration: this.options.durationRegular,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureC,
        translateY: ['-40px', '0'],
        delay: 200,
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureC,
          opacity: [0, 1],
          delay: 200,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureC,
          filter: ['blur(10px)', 'blur(0px)'],
          delay: 200,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      }
    }
  },

  components: {
    Img
  }
}
</script>
